export const ALERTS_POSITION_WIDGET = 3;
export const REFUNDABLE_POSITION_WIDGET = 1;
export const TOPZONES_POSITION_WIDGET = 4;
export const FLIGHTS_STEP_WIDGET = 8;
export const FLIGHTS_EXCHANGE_STEP_WIDGET = 16;
export const HOTELS_STEP_WIDGET = 8;
